import React from 'react'
// nodejs library to set properties for components
import PropTypes from 'prop-types'
// @material-ui/core components
import Grid from '@material-ui/core/Grid'





export default function GridContainer(props) {
    const {children, ...rest} = props
    return (
        <Grid container spacing={3} {...rest} className={`grid_container ${props.cssClass || ''}`}>
            {children}
        </Grid>
    )
}

GridContainer.propTypes = {
    children: PropTypes.node,
}
